import React from 'react';

import { ITabPanelRightProps } from './types';
import classes from './TabPanel.module.scss';

const TabPanelRightContent: React.FC<ITabPanelRightProps> = (props) => {
    const { orientation, isNew, renderTabPanelRightContent } = props;
    const isVerticalOrientationAndNewTab = orientation === 'vertical' && isNew;
    return (
        <>
            {isVerticalOrientationAndNewTab ? (
                <span className={classes.right}>
                    {renderTabPanelRightContent}
                    <span className={classes.DotVerticalTab}></span>
                </span>
            ) : (
                <span className={classes.right}>{renderTabPanelRightContent}</span>
            )}
        </>
    );
};

export default TabPanelRightContent;
